import React, { useEffect, useState } from "react"
import Col from "@bappweb/col"
import Grid from "@bappweb/grid"
import Row from "@bappweb/row"
import Block from "@bappweb/block"
import { pushGtmValues } from "@bappweb/utils"
import MainForm from "./form"
import LandingHeader from "./landingheader"
import Notes from "./notes"
import Campaign from "./campaign"
import SssList from "./ssslist"
import { getCidParameter, getConfigValue, isNullOrEmpty } from "@smpu-web/utils/utils"
import { useAppSelector } from "../../../config/hook"

const Landing = () => {
    const sessionData = useAppSelector((state) => state.sessionData.response)

    const [oranTable, setOranTable] = useState(true);
    useEffect(() => {
        let cidParameter = getCidParameter();
        if (cidParameter != null) {
            if (!isNullOrEmpty(getConfigValue(sessionData?.configList, `PosLead.Landing.Seo.Faq.${cidParameter}`))) {
                const faqElement = document.createElement("script")
                faqElement.type = "application/ld+json"
                faqElement.textContent = getConfigValue(sessionData?.configList, `PosLead.Landing.Seo.Faq.${cidParameter}`)
                document.head.appendChild(faqElement)
            }
            else {
                if (!isNullOrEmpty(getConfigValue(sessionData?.configList, "PosLead.Landing.Seo.Faq"))) {
                    const faqElement = document.createElement("script")
                    faqElement.type = "application/ld+json"
                    faqElement.textContent = getConfigValue(sessionData?.configList, "PosLead.Landing.Seo.Faq")
                    document.head.appendChild(faqElement)
                }
            }
        }
        else {
            if (!isNullOrEmpty(getConfigValue(sessionData?.configList, "PosLead.Landing.Seo.Faq"))) {
                const faqElement = document.createElement("script")
                faqElement.type = "application/ld+json"
                faqElement.textContent = getConfigValue(sessionData?.configList, "PosLead.Landing.Seo.Faq")
                document.head.appendChild(faqElement)
            }
        }

    }, [sessionData])

    useEffect(() => {
        pushGtmValues({
            event: "virtual_page_view",
            content_group: "pos-lead",
            pageName: 'basvuru/poslead/0/landing',
            pageTitle: 'Pos Lead Başvurusu'
        })
    }, []);

    useEffect(() => {
        let cidParameter = getCidParameter();
        if (cidParameter != null) {
            if (!isNullOrEmpty(getConfigValue(sessionData?.configList, `PosLead.Campaign.Table.Flag.${cidParameter}`))) {
                setOranTable(getConfigValue(sessionData?.configList, `PosLead.Campaign.Table.Flag.${cidParameter}`) == "E" ? true : false);
            }
        }
    }, [sessionData])


    return (
        <Block type="section" className="landing-page-wrapper" id="landing-page-wrapper">
            <LandingHeader />
            <Grid type="main" className="landing-page-main">
                <Row>
                    <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
                        <MainForm />
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
                        <Notes />
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
                        <SssList />
                    </Col>
                </Row>
                {oranTable &&
                    <Row>
                        <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
                            <Campaign />
                        </Col>
                    </Row>
                }

            </Grid>
        </Block>
    )
}

export default Landing
